import { Text, View } from '@react-pdf/renderer';
import { dateObjToLocalZone } from '../../utils/converter';
import { infoBoxes } from '../../styles/pdfStyles/infoBoxStyles';

const ValidationInfoPDF = ({ reportData }) => {
  return (
    <View style={[infoBoxes.container, infoBoxes.verificationContainer]}>
      <Text style={infoBoxes.title}>Verification Information</Text>

      <View style={infoBoxes.section}>
        <Text style={infoBoxes.label}>Date:</Text>

        <Text style={infoBoxes.value}>{dateObjToLocalZone(reportData.VALIDATION_DATE)}</Text>
      </View>
      <View style={infoBoxes.section}>
        <Text style={infoBoxes.label}>Result:</Text>
        <View>
          <Text>{+reportData.VALID ? 'Full match' : 'No match'}</Text>
        </View>
      </View>

      <View style={infoBoxes.section}>
        <Text style={infoBoxes.label}>Verification Method:</Text>
        <Text style={infoBoxes.value}>Stamped</Text>
      </View>
    </View>
  );
};

export default ValidationInfoPDF;
